import { render, staticRenderFns } from "./editStuttieAddress.vue?vue&type=template&id=0bf90c92&scoped=true&"
import script from "./editStuttieAddress.vue?vue&type=script&lang=js&"
export * from "./editStuttieAddress.vue?vue&type=script&lang=js&"
import style0 from "./editStuttieAddress.vue?vue&type=style&index=0&id=0bf90c92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf90c92",
  null
  
)

export default component.exports